import { MatDialog } from '@angular/material/dialog';
import { PoolerType } from 'server/shared/models/poolerType';
import { PoolerUser } from 'server/shared/models/user';
import { getBookingConfirmationThroughDialog } from '../getBookingConfirmationThroughDialog';
import { uniqueBy } from '../uniqueBy';

export interface BookingWarningUser {
  user: PoolerUser;
  poolerType: PoolerType;
  dialogId: string;
}

export async function processBookingWarnings(
  users: {
    // undefined for external users
    user: PoolerUser | undefined;
    poolerType?: PoolerType;
  }[],
  dialog: MatDialog,
  i18n?: any,
): Promise<boolean> {
  // Deduplicate users by _id - keep only the first occurrence of each user
  const uniqueUsers = uniqueBy(
    users.filter(
      (u): u is { user: PoolerUser; poolerType?: PoolerType } =>
        u.user !== undefined,
    ),
    ({ user }) => user._id,
  );

  const usersNeedingWarning = uniqueUsers
    .map(({ user, poolerType }) => ({
      user: user,
      poolerType: poolerType,
    }))
    // those who have a pooler type
    .filter(
      (u): u is { user: PoolerUser; poolerType: PoolerType } =>
        u.poolerType !== undefined,
    )
    .filter(({ poolerType }) => {
      return poolerType && poolerType.bookingWarningEnabled;
    })
    .map(({ user, poolerType }) => ({
      user: user,
      poolerType: poolerType,
    }));

  if (usersNeedingWarning.length === 0) {
    return true;
  }

  // Process warnings sequentially
  for (const { user, poolerType } of usersNeedingWarning) {
    const warningText =
      poolerType?.bookingWarningMessage ||
      i18n?.poolerTypeBookingWarningDefaultMessage?.replace(
        '{{poolerType}}',
        poolerType?.displayName || '',
      ) ||
      '';
    const title =
      i18n?.bookingWarningTitle
        ?.replace(/\{\{firstName\}\}/g, user.firstName)
        ?.replace(/\{\{lastName\}\}/g, user.lastName) ||
      `Buchungswarnung für ${user.firstName} ${user.lastName}`;

    const result = await getBookingConfirmationThroughDialog(
      dialog,
      user._id + '-book-warning',
      warningText,
      title,
    );

    if (!result) {
      return false;
    }
  }
  return true;
}
